import CaratPlanViewer from '@/components/KitchenPlanning/Carat/CaratPlanViewer';
import { useCaratPlannings } from '@/components/ProjectDetails/useCaratPlannings';
import { CaratPlanningModel } from '@/typings/models/CaratModel';
import { LeadDetailsModel } from '@/typings/models/Lead';
import { Flex, Segmented } from 'antd';
import React, { useState } from 'react';
import KPSMaxPlanViewer from './KPSMaxPlanViewer';

export interface PlanningProps {
  leadDetails?: LeadDetailsModel;
  leadId?: string;
  /**
   * Plannings the caller already loaded (the lead details card does). Left out,
   * they are fetched for `leadId`.
   */
  plannings?: CaratPlanningModel[];
  selectedPlanning?: CaratPlanningModel;
}

const PLANNING_TYPES = {
  KPS_MAX: 'kps-max',
  CARAT: 'carat',
} as const;

/**
 * The kitchen planning of one project: the plannings pushed by the studio's
 * planning software. Carat is live (CLICKUP-86cb5zayy); KPS Max is the second
 * planner we expect to integrate and still a placeholder.
 */
const Planning: React.FC<PlanningProps> = ({
  leadDetails,
  leadId,
  plannings,
  selectedPlanning,
}) => {
  const [activePlanningType, setActivePlanningType] = useState<string>(
    PLANNING_TYPES.CARAT,
  );
  const fetched = useCaratPlannings(plannings ? undefined : leadId);

  const caratPlannings = plannings ?? fetched.plannings;

  // Product names, not copy — neither is translated.
  const segmentedOptions = [
    { label: 'KPS Max', value: PLANNING_TYPES.KPS_MAX },
    { label: 'Carat', value: PLANNING_TYPES.CARAT },
  ];

  return (
    <Flex vertical gap={16}>
      <div>
        <Segmented
          options={segmentedOptions}
          value={activePlanningType}
          onChange={setActivePlanningType}
        />
      </div>

      {activePlanningType === PLANNING_TYPES.KPS_MAX ? (
        <KPSMaxPlanViewer leadDetails={leadDetails} leadId={leadId} />
      ) : (
        <CaratPlanViewer
          plannings={caratPlannings}
          leadDetails={leadDetails}
          loading={plannings ? false : fetched.loading}
          selectedPlanning={selectedPlanning}
        />
      )}
    </Flex>
  );
};

export default Planning;
